import { omit } from 'lodash'
import { getInsureOrderList } from '@/api/domain/purchase'
import { ORDER_STATUS_MAP } from '../enum'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

const mainTabList = [
  {
    name: '全部',
    code: 'all',
    count: 0,
  },
  {
    name: '保险报价',
    code: 'insuranceQuotation',
    count: 0,
  },
  {
    name: '保险核保',
    code: 'insuranceUnderwriting',
    count: 0,
  },
  {
    name: '待支付',
    code: 'waitingPaying',
    count: 0,
  },
  {
    name: '待确认',
    code: 'waitingConfirm',
    count: 0,
  },
  {
    name: '已完成',
    code: 'done',
    count: 0,
  },
  {
    name: '已关闭',
    code: 'closed',
    count: 0,
  },
]

const subQuotationTabList = [
  {
    name: '全部',
    code: 'insuranceQuotation',
    count: 0,
  },
  {
    name: '待反馈报价',
    code: 'waitingQuotation',
    count: 0,
  },
  {
    name: '报价失败',
    code: 'failQuotation',
    count: 0,
  },
]

const subUnderwritingTabList = [
  {
    name: '全部',
    code: 'insuranceUnderwriting',
    count: 0,
  },
  {
    name: '待确认核保',
    code: 'waitingUnderwriting',
    count: 0,
  },
  {
    name: '确认中',
    code: 'waiting',
    count: 0,
  },
  {
    name: '核保失败',
    code: 'failUnderwriting',
    count: 0,
  },
]

const getConfigData = (router, baseListManagementRef) => {
  return {
    formData: {
      formProps: {
        model: {
          status: 'all',
        },
      },
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '车牌号',
            prop: 'plateNo',
          },
          elConfig: {
            maxLength: 20,
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '单据编号',
            prop: 'documentNo',
          },
          elConfig: {
            maxLength: 100,
            placeholder: '请输入',
          },
        },
        {
          itemConfig: {
            prop: 'brandSeriesModel',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
          },
          render: 'CarBrandSeriesModel',
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '创建时间',
            prop: 'createDate',
          },
        },
      ],
      customizeReset: () => {
        baseListManagementRef.value.setItemData({
          elConfigKey: 'value',
          key: 'brandSeriesModel',
          data: {},
        })
      },
      dealWithSearch: (params) => {
        const { brandSeriesModel } = params
        return {
          brandId: brandSeriesModel?.brandId,
          seriesId: brandSeriesModel?.seriesId,
          modelId: brandSeriesModel?.modelId,
        }
      },
    },
    tableData: {
      columns: [
        {
          name: 'documentNo',
          columnProps: {
            label: '单据编号',
            prop: 'documentNo',
          },
        },
        {
          name: 'plateNo',
          columnProps: {
            label: '车牌号',
            prop: 'plateNo',
          },
        },
        {
          name: 'brandName',
          columnProps: {
            label: '品牌',
            prop: 'brandName',
          },
        },
        {
          name: 'seriesName',
          columnProps: {
            label: '车系',
            prop: 'seriesName',
          },
        },
        {
          name: 'modelName',
          columnProps: {
            label: '车型',
            prop: 'modelName',
          },
        },
        {
          name: 'driverName',
          columnProps: {
            label: '车主',
            prop: 'driverName',
          },
        },
        {
          name: 'insureApplicantName',
          columnProps: {
            label: '投保人',
            prop: 'insureApplicantName',
          },
        },
        {
          name: 'insureUseName',
          columnProps: {
            label: '被投保人',
            prop: 'insureUseName',
          },
        },
        {
          name: 'adCodeName',
          columnProps: {
            label: '报价城市',
            prop: 'adCodeName',
          },
        },
        {
          name: 'gmtCreate',
          columnProps: {
            label: '创建时间',
            prop: 'gmtCreate',
          },
        },
        {
          name: 'stateName',
          columnProps: {
            label: '单据状态',
            prop: 'stateName',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            prop: 'operate',
            fixed: 'right',
          },
          getOperateList: ({ row }) => {
            const isComplete =
                  [ORDER_STATUS_MAP.CLOSED, ORDER_STATUS_MAP.SUCCESS].includes(row.status)
            const btnList = []
            if (isComplete) {
              btnList.push({
                name: 'detail',
                label: '查看',
                action: () => {
                  router.push({
                    path: '/purchaseProvide/carInsuranceCompare/detail',
                    query: {
                      orderId: row.orderId,
                    },
                  })
                },
              })
            } else {
              btnList.push({
                name: 'progress',
                label: '查看进度',
                action: () => {
                  router.push({
                    path: '/purchaseProvide/carInsuranceCompare/detail',
                    query: {
                      orderId: row.orderId,
                    },
                  })
                },
              })
            }
            return btnList
          },
          type: 'operate',
        },
      ],
      apiFn: (params) => {
        const [createStartDate = '', createEndDate = ''] = params.createDate || []

        return getInsureOrderList({
          ...omit(params, ['createDate']),
          createStartDate,
          createEndDate,
        })
      },
    },
    isShowDepartment: false,
  }
}


export default { mainTabList, subQuotationTabList, subUnderwritingTabList, getConfigData }
